import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useSwipeable } from 'react-swipeable';

import { toggleSnackBar } from 'actions/appAction';

import { useApp } from 'hooks/selectors';

import { Container, InnerContent, SnackBarContainer } from './styles';

export const SnackBar = () => {
    const dispatch = useDispatch();
    const timerId = useRef(null);
    const { isShowSnackBar: isShown, messageForSnackBar: message } = useApp();

    useEffect(() => {
        if (isShown) {
            if (timerId.current) {
                return;
            }
            timerId.current = setTimeout(close, 2500);
        }
        return () => {
            clearTimeout(timerId.current);
        };
    }, [isShown]);

    const onSwipe = useSwipeable({
        onSwipedUp: () => close(),
        preventDefaultTouchmoveEvent: true,
        trackTouch: true,
    });

    const close = () => {
        clearTimeout(timerId.current);
        timerId.current = null;
        dispatch(toggleSnackBar(false, null));
    };

    const snackBar = (
        <Container>
            <SnackBarContainer>
                <InnerContent {...onSwipe} data-testid="snack-content" onClick={close}>
                    {message}
                </InnerContent>
            </SnackBarContainer>
        </Container>
    );
    return isShown ? snackBar : null;
};

export default SnackBar;
